import './job-openings.scss';
import { init as initDropdown } from '../../ui/dropdown/index';

// @ts-ignore
const FILTERS = window.JOB_OPERATIONS || [];

interface IElements {
  form: null | HTMLElement | NodeListOf<HTMLElement>;
  activeFilterContainer: null | HTMLElement | NodeListOf<HTMLElement>;
  activeFilterContainerItems: null | HTMLElement | NodeListOf<HTMLElement>;
  clearButton: null | HTMLElement | NodeListOf<HTMLElement>;
  cards: null | HTMLElement | NodeListOf<HTMLElement>;
  filters: {
    [key: string]: any;
  };
}

const selectors: Record<
  | 'form'
  | 'activeFilterContainer'
  | 'activeFilterContainerItems'
  | 'clearButton'
  | 'tag'
  | 'card',
  string
> = {
  form: '[data-job-operations-form]',
  activeFilterContainer: '[data-job-operations-filter-container]',
  activeFilterContainerItems: '[data-job-operations-filter-items]',
  clearButton: '[data-job-operations-filter-clear]',
  tag: '[data-job-filter-tag]',
  card: '[data-job-card]',
};

const elements: IElements = {
  form: null,
  activeFilterContainer: null,
  activeFilterContainerItems: null,
  clearButton: null,
  cards: null,
  filters: {},
};

const classes: Record<'hidden', string> = {
  hidden: 'hidden',
};

function getActiveFilters() {
  return Object.keys(elements.filters).reduce((acc, item) => {
    if (elements.filters[item].length) {
      // @ts-ignore
      return { ...acc, [item]: elements.filters[item] };
    }

    return acc;
  }, false);
}

function tagTemplate(label = '', name = '', value = '', type = 'radio') {
  return `
  <label class="ui-filter ui-filter--color-dark" data-job-filter-tag data-job-filter-name="${name}" data-job-filter-value="${value}">
    <span class="body-200 lg:body-300">${label}</span>
    <div class="icon " style="width: 16px; height: 16px">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="M7.69231 18L6 16.3077L10.3077 12L6 7.69231L7.69231 6L12 10.3077L16.3077 6L18 7.69231L13.6923 12L18 16.3077L16.3077 18L12 13.6923L7.69231 18Z" fill="currentColor"></path>
        </g>
      </svg>
    </div>
  </label>
  `;
}

function filterCards() {
  if (!elements.cards) return;

  const activeFilters = getActiveFilters();

  // @ts-ignore
  const filteredCard = Object.keys(activeFilters).reduce((acc, name) => {
    if (!activeFilters) return acc;

    // @ts-ignore
    const value = activeFilters[name] as string | string[];

    if (typeof value === 'object') {
      // @ts-ignore
      return value.reduce((accCards, value) => {
        const cards = acc.filter((card) => {
          const cardValues = (
            card.getAttribute(`data-job-card-filter-${name}`) || ''
          )
            .split(',')
            .filter((i) => i !== '');
          return cardValues.includes(value);
        });

        // @ts-ignore
        const findCard = cards.filter((c) => !accCards.includes(c));

        if (findCard.length) {
          return [...accCards, ...findCard];
        }

        return accCards;
      }, []);
    } else {
      return acc.filter((card) => {
        const cardValues = (
          card.getAttribute(`data-job-card-filter-${name}`) || ''
        )
          .split(',')
          .filter((i) => i !== '');

        return cardValues.includes(value);
      });
    }
    // @ts-ignore
  }, Array.from(elements.cards));

  // @ts-ignore
  Array.from(elements.cards).forEach((card) => {
    // @ts-ignore
    return card.classList[filteredCard.includes(card) ? 'remove' : 'add'](
      classes.hidden
    );
  });
}

function clearFilter(e: Event) {
  const target = e.target as EventTarget;
  const tags = document.querySelectorAll(selectors.tag);

  Array.from(tags).forEach((tag) => {
    // @ts-ignore
    if (tag.contains(target)) {
      const value = tag.getAttribute('data-job-filter-value');
      const name = tag.getAttribute('data-job-filter-name') as string;

      if (typeof elements.filters[name] === 'object') {
        elements.filters[name] = elements.filters[name].filter(
          (v: string) => v !== value
        );
      } else {
        elements.filters[name] = '';
      }
    }
  });

  setFilters();
  syncElementsForm();
}

function syncElementsForm() {
  const activeFilters = getActiveFilters();

  if (!activeFilters) {
    FILTERS.map((i: any) => i.name).forEach((name: string) => {
      const inputs = document.querySelectorAll(
        `[name="${name}"]`
      ) as NodeListOf<HTMLInputElement>;
      Array.from(inputs).forEach((input) => {
        input.removeAttribute('checked');
      });
    });
    reInitDropdowns();
  }

  Object.entries(activeFilters).forEach(([name, value]) => {
    const inputs = document.querySelectorAll(
      `[name="${name}"]`
    ) as NodeListOf<HTMLInputElement>;

    if (typeof value === 'object') {
      value.map((v: string) => {
        Array.from(inputs).forEach((input) => {
          if (input.getAttribute('value') === v) {
            input.setAttribute('checked', 'true');
          } else {
            input.removeAttribute('checked');
          }
        });
      });
    }
  });

  reInitDropdowns();
}

function reInitDropdowns() {
  // @ts-ignore
  window.tippyInstances.forEach((instance) => {
    instance.destroy();
  });

  initDropdown();
}

function clearAllFilters() {
  elements.filters = {};

  reInitDropdowns();
  setFilters();
}

function setFilters() {
  if (!elements.activeFilterContainerItems) return;

  // @ts-ignore
  elements.activeFilterContainerItems.innerHTML = '';

  let tags: string[] = [];

  FILTERS.forEach((filter: any) => {
    const values = elements.filters[filter.name];

    if (values && values.length) {
      if (typeof values === 'object') {
        tags = [
          ...tags,
          ...values.map((value: string) => {
            const data = filter.items.find((i: any) => i.value === value);
            return tagTemplate(data.label, filter.name, data.value, 'checkbox');
          }),
        ];
      } else {
        const data = filter.items.find((i: any) => i.value === values);
        tags = [
          ...tags,
          tagTemplate(data.label, filter.name, data.value, 'radio'),
        ];
      }
    }
  });

  // @ts-ignore
  elements.activeFilterContainerItems.innerHTML = tags.join('');
  // @ts-ignore
  elements.activeFilterContainer.classList[tags.length ? 'remove' : 'add'](
    classes.hidden
  );

  filterCards();
}

function changeForm(e: Event) {
  e.preventDefault();

  const target = e.currentTarget as HTMLFormElement;

  Array.from(target.elements, (element) => {
    //@ts-ignore
    const { name, value, type, checked } = element;

    if (type === 'text') {
      elements.filters[name] = value;
    }

    if (type === 'radio' && checked) {
      elements.filters[name] = value;
    }

    if (type === 'checkbox') {
      elements.filters[name] = elements.filters[name] || [];

      if (checked && !elements.filters[name]?.includes(value)) {
        elements.filters[name] = [...elements.filters[name], value];
      }
    }
    if (['submit', 'range', 'button'].includes(type)) return;
  });

  const targetElement = e.target as HTMLFormElement;

  if (targetElement.type === 'checkbox') {
    if (
      !targetElement.checked &&
      elements.filters[targetElement.name]?.includes(targetElement.value)
    ) {
      elements.filters[targetElement.name] = elements.filters[
        targetElement.name
      ].filter((v: string) => v !== targetElement.value);
    }
  }

  setFilters();
}

function init() {
  elements.form = document.querySelector(selectors.form) as HTMLElement;
  elements.activeFilterContainer = document.querySelector(
    selectors.activeFilterContainer
  ) as HTMLElement;
  elements.activeFilterContainerItems = document.querySelector(
    selectors.activeFilterContainerItems
  ) as HTMLElement;
  elements.clearButton = document.querySelector(
    selectors.clearButton
  ) as HTMLElement;
  elements.cards = document.querySelectorAll(
    selectors.card
  ) as NodeListOf<HTMLElement>;

  if (!elements.form) return;

  elements.form.addEventListener('change', changeForm);

  elements.activeFilterContainerItems.addEventListener('click', clearFilter);

  if (elements.clearButton) {
    elements.clearButton.addEventListener('click', clearAllFilters);
  }
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init();
  },
  { once: true }
);
